const BASE_URL = process.env.REACT_APP_BASE_URL

export const OAUTH_REDIRECT_URL = `${BASE_URL}/login/oauth`
export const PENDING_WELCOME_STORAGE_KEY = 'pendingAccountSegmentWelcome'

const UTM_PARAMETERS = [
  { key: 'utmSource', param: 'utm_source' },
  { key: 'utmCampaign', param: 'utm_campaign' },
  { key: 'utmMedium', param: 'utm_medium' },
  { key: 'utmTerm', param: 'utm_term' },
  { key: 'utmContent', param: 'utm_content' },
  { key: 'utmId', param: 'utm_id' },
]

const computeOrigin = (searchParams) => {
  if (localStorage.getItem('communityId')) {
    return 'invitation'
  } else if (localStorage.getItem('redirectUrl')) {
    return 'program_registration'
  } else if (searchParams.get('utm_source')) {
    return 'campaign'
  }

  return null
}

const extractUtmParams = (searchParams) => (
  Object.fromEntries(UTM_PARAMETERS.map(({ key, param }) => [key, searchParams.get(param)]).filter(([, value]) => value))
)

export const buildOAuthState = (segment = null, communityId = null, origin = null, utmParams = {}) => {
  if (segment && origin !== 'program_registration') {
    localStorage.setItem(PENDING_WELCOME_STORAGE_KEY, 'true')
  }

  return JSON.stringify({
    ...(segment && { segment }),
    ...(communityId && { communityId }),
    ...(origin && { origin }),
    ...utmParams,
  })
}

export const buildStateFromParams = (segment = null, communityId = null, searchParams = new URLSearchParams()) => {
  const origin = computeOrigin(searchParams)
  const utmParams = extractUtmParams(searchParams)

  return buildOAuthState(segment, communityId, origin, utmParams)
}
